var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 136 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 39.3432V4.56258C1 2.59502 2.59502 1 4.56258 1H37.9618M1 99.9072V134.152C1 136.119 2.59503 137.714 4.56259 137.714H37.9618M134.597 39.3432V4.56258C134.597 2.59502 133.002 1 131.034 1H99.8617M134.597 99.9072V134.152C134.597 136.119 133.002 137.714 131.034 137.714H99.8617",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBoxIcon);
export default __webpack_public_path__ + "static/media/faceBoxIcon.fe5ac51a.svg";
export { ForwardRef as ReactComponent };